import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["image", "lightbox", "lightboxImage"]
    static values = { currentIndex: Number }

    connect() {
        this.currentIndexValue = 0
        this.updateBorders()
        this.imageLoader(this.imageTargets, 0)

        this.handleKeydown = this.handleKeydown.bind(this)
    }

    showImage(event) {
        const thumbnailIndex = parseInt(event.currentTarget.dataset.thumbnailIndex)
        this.goToImage(thumbnailIndex)
    }

    previousImage() {
        const images = this.imageTargets
        let goToId

        images.forEach((image) => {
            if (image != undefined && image.classList.contains("block")) {
                const imageId = parseInt(image.id.replace("carousel_image_", ""))
                if (imageId <= 0) {
                    goToId = this.imageTargets.length - 1
                } else {
                    goToId = imageId - 1
                }
            }
        })

        this.goToImage(goToId)
    }

    nextImage() {
        const images = this.imageTargets
        let goToId

        images.forEach((image) => {
            if (image != undefined && image.classList.contains("block")) {
                const imageId = parseInt(image.id.replace("carousel_image_", ""))
                if (imageId >= this.imageTargets.length - 1) {
                    goToId = 0
                } else {
                    goToId = imageId + 1
                }
            }
        })

        this.goToImage(goToId)
    }

    goToImage(index) {
        if (!this.imageTargets[index]) return

        this.targetToggler(this.imageTargets, index)
        if (this.hasLightboxImageTarget && this.hasLightboxTarget && !this.lightboxTarget.classList.contains("hidden")) {
            this.targetToggler(this.lightboxImageTargets, index, false)
        }

        this.currentIndexValue = index
        this.updateBorders()
    }

    targetToggler(targets, index, preloadNeighbours = true) {
        const selectedTarget = targets[index]
        if (!selectedTarget) return

        targets.forEach((image) => {
            image.classList.remove("block")
            if (!image.classList.contains("hidden")) {
                image.classList.add("hidden")
            }
        })

        selectedTarget.classList.remove("hidden")
        if (!selectedTarget.classList.contains("block")) {
            selectedTarget.classList.add("block")
        }

        this.imageLoader(targets, index, preloadNeighbours)
    }

    // Check if image is loaded and load it per link in input
    imageLoader(targets, index, preloadNeighbours = true) {
        if (!targets[index]) return

        const indices = preloadNeighbours ? [
            index,
            index + 1 >= targets.length ? 0 : index + 1,
            index - 1 < 0 ? targets.length - 1 : index - 1
        ] : [index]

        indices.forEach(i => {
            const target = targets[i]
            if (!target) return

            const input = target.querySelector("#image-backend-url")
            const imageElement = target.querySelector("#image")
            if (input && imageElement && imageElement.src !== input.value) {
                imageElement.src = input.value
            }
        })
    }

    openLightbox() {
        if (this.hasLightboxTarget) {
            this.targetToggler(this.lightboxImageTargets, this.currentIndexValue, false)
            this.lightboxTarget.classList.remove("hidden")
            document.body.style.overflow = "hidden"
            document.addEventListener("keydown", this.handleKeydown)
        }
    }

    closeLightbox(event) {
        if (event) {
            event.preventDefault()
            event.stopPropagation()
        }

        if (this.hasLightboxTarget) {
            this.lightboxTarget.classList.add("hidden")
            document.body.style.overflow = ""
            document.removeEventListener("keydown", this.handleKeydown)
        }
    }

    stopPropagation(event) {
        event.stopPropagation()
    }

    previousImageLightbox(event) {
        event.stopPropagation()
        this.previousImage()
    }

    nextImageLightbox(event) {
        event.stopPropagation()
        this.nextImage()
    }

    handleKeydown(event) {
        switch (event.key) {
            case "Escape":
                this.closeLightbox()
                break
            case "ArrowLeft":
                this.previousImage()
                break
            case "ArrowRight":
                this.nextImage()
                break
        }
    }

    updateBorders() {
        const thumbnails = this.element.querySelectorAll("[data-thumbnail-index]")
        thumbnails.forEach((thumbnail, index) => {
            if (index === this.currentIndexValue) {
                thumbnail.classList.add("border-blue-500")
                thumbnail.classList.remove("border-gray-300")
            } else {
                thumbnail.classList.add("border-gray-300")
                thumbnail.classList.remove("border-blue-500")
            }
        })
    }

    disconnect() {
        document.removeEventListener("keydown", this.handleKeydown)
        document.body.style.overflow = ""
    }
}
